import { SeparatorLine } from "@stenajs-webui/core";
import * as React from "react";
import { useContext } from "react";
import {
  PriceCalculatorContext,
  PriceCalculatorContextType,
} from "../../PriceCalculatorContext";
import { MovementType } from "../../types/types";
import { PriceCalculatorMovementTypeSelect } from "./common/PriceCalculatorMovementTypeSelect";
import { PriceCalculatorMultiLegOptions } from "./multi-leg/PriceCalculatorMultiLegOptions";
import { PriceCalculatorSectionalOptions } from "./sectional/PriceCalculatorSectionalOptions";

export const PriceCalculatorCustomerForm: React.FC = () => {
  const { formData } = useContext(
    PriceCalculatorContext
  ) as PriceCalculatorContextType;
  return (
    <>
      <PriceCalculatorMovementTypeSelect />
      <SeparatorLine />
      {formData.movementType === MovementType.SECTIONAL ? (
        <PriceCalculatorSectionalOptions />
      ) : (
        <PriceCalculatorMultiLegOptions />
      )}
    </>
  );
};
